import {createRoute} from "@tanstack/react-router"
import {rootRoute} from "@/routing/router"
import IndexPage from "@/pages"
import SignInPage from "@/pages/sign-in"

export const indexRoute = createRoute({
    path: "/",
    getParentRoute: () => rootRoute,
    component: IndexPage
})

export const authRoute = createRoute({
    path: "/auth",
    getParentRoute: () => rootRoute,
})

export const signInRoute = createRoute({
    path: "/sign-in",
    staticData: {
        pageInfo: {
            pageTitle: "Logg inn"
        }
    },
    getParentRoute: () => authRoute,
    component: SignInPage
})
